export default __webpack_public_path__ + "static/images/logo-mamaclean-plus-dc2cd43ba40037a603d835a9747fe013.png";